module.exports = require("font-awesome-icon-chars");


//////////////////
// WEBPACK FOOTER
// external "font-awesome-icon-chars"
// module id = 5
// module chunks = 0